import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {UmpirePushNotificationTarget} from '@tisa-group/models';

@Injectable()
export class PushNotificationTargetService
  implements CrudService<UmpirePushNotificationTarget>
{
  constructor(readonly http: TisaUmpireHttpService) {}

  list(
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePushNotificationTarget[]>> {
    return this.http
      .get(`/push_notification_targets`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/push_notification_targets/${id}`);
  }

  create(
    body: Partial<UmpirePushNotificationTarget>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePushNotificationTarget>> {
    return this.http
      .post<JsonApiResponse<UmpirePushNotificationTarget>>(
        '/push_notification_targets',
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePushNotificationTarget>> {
    return this.http
      .get(`/push_notification_targets/${fetchIdentifier}`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpirePushNotificationTarget>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePushNotificationTarget>> {
    return this.http
      .patch<JsonApiResponse<UmpirePushNotificationTarget>>(
        `/push_notification_targets/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }
}
